import { SvgIcon } from "@mui/material"

import { ReactComponent as Equipment } from "./Equipment-icon.svg"

export const EquipmentIcon = (props) => {
    return (
        <SvgIcon component={Equipment} inheritViewBox {...props} />
    )
}
